import { relations } from 'drizzle-orm'
import { pgTable, text } from 'drizzle-orm/pg-core'
import { getBaseFields, getBaseIndexes } from '../common/utils'
import { employeeCertificates } from './employeeCertificate'

// Master list of certificates that can be assigned to employees.
// Managed in the ERP configuration view.
export const certificates = pgTable(
  'certificates',
  {
    ...getBaseFields(),
    name: text().notNull().unique(),
    description: text(),
  },
  (table) => getBaseIndexes('certificates', table),
)

export const certificatesRelations = relations(certificates, ({ many }) => ({
  employeeCertificates: many(employeeCertificates),
}))
